/**
 * Archivo: Filtros.js
 * Autor: Acher Egido Mairal
 * Fecha de última modificación: 20/08/2024
 * 
 * Descripción:
 * Este componente representa la interfaz de usuario para aplicar filtros sobre un conjunto de elementos, 
 * permitiendo a los usuarios refinar la visualización de datos según criterios como género, promoción, 
 * pasillo, adjuntos y favoritos. Los filtros se aplican mediante el uso de botones de alternancia, y 
 * el componente incluye la funcionalidad para restablecer todos los filtros a sus valores predeterminados.
 * 
 * Dependencias:
 * - react: ^18.2.0
 * - estilos.css: Hoja de estilos personalizada
 * - ToggleButton: Componente personalizado que se utiliza para los botones toggle
 * 
 * Propósito:
 * Proporcionar una interfaz de usuario para aplicar filtros a los elementos mostrados en la aplicación.
 */

import { ToggleButton } from "./ToggleButton";
import '../Estilos/estilos.css';

import favoritosBlanco from '../Imagenes/Iconos/FavoritosBlanco.png'
import cruzBlanca from '../Imagenes/Iconos/CruzBlanca.png'

const Filtros = ({ onClose, selectedHombre, setSelectedHombre, selectedMujer, setSelectedMujer, selectedOtro, setSelectedOtro, 
    selectedPrimera, setSelectedPrimera, selectedSegunda, setSelectedSegunda, selectedTercera, setSelectedTercera, selectedCuarta, 
    setSelectedCuarta, selectedQuinta, setSelectedQuinta, selected100, setSelected100, selected200, setSelected200, selected300, 
    setSelected300, selected400, setSelected400, selectedAdjuntos, setSelectedAdjuntos, selectedFavoritos, setSelectedFavoritos,
    ordenacion, setOrdenacion }) => {
    const handleToggleHombre = () => {
      setSelectedHombre(!selectedHombre);
    };
    const handleToggleMujer = () => {
      setSelectedMujer(!selectedMujer);
    };
    const handleToggleOtro = () => {
      setSelectedOtro(!selectedOtro);
    };
    const handleTogglePrimera = () => {
      setSelectedPrimera(!selectedPrimera);
    };
    const handleToggleSegunda = () => {
      setSelectedSegunda(!selectedSegunda);
    };
    const handleToggleTercera = () => {
      setSelectedTercera(!selectedTercera);
    };
    const handleToggleCuarta = () => {
      setSelectedCuarta(!selectedCuarta);
    };
    const handleToggleQuinta = () => {
      setSelectedQuinta(!selectedQuinta);
    };
    const handleToggle100 = () => {
      setSelected100(!selected100);
    };
    const handleToggle200 = () => {
      setSelected200(!selected200);
    };
    const handleToggle300 = () => {
      setSelected300(!selected300);
    };
    const handleToggle400 = () => {
      setSelected400(!selected400);
    };
    const handleToggleAdjuntos = () => {
      setSelectedAdjuntos(!selectedAdjuntos);
    };
    const handleToggleFavoritos = () => {
      setSelectedFavoritos(!selectedFavoritos);
    };

    const vaciarFiltros = () => {
      setSelectedHombre(false);
      setSelectedMujer(false);
      setSelectedOtro(false);
      setSelectedPrimera(false);
      setSelectedSegunda(false);
      setSelectedTercera(false);
      setSelectedCuarta(false);
      setSelectedQuinta(false);
      setSelected100(false);
      setSelected200(false);
      setSelected300(false);
      setSelected400(false);
      setSelectedAdjuntos(false);
      setSelectedFavoritos(false);
      setOrdenacion('nombre');
  };

    return (
      <div>
      <div className="container col-xl-8 col-lg-9 col-md-10 col-12 bdr-1 rounded p-xl-2 p-lg-1 p-md-0 position-fixed text-center " style={{ fontWeight: '3rem', background: '#303030', top: '44%', left: '50%', transform: 'translate(-50%, -40%)', zIndex:'5' }}>
        <div className="row-fluid pb-0 d-flex justify-content-center">
          <div className="container col-12 pb-0 text-center mt-xl-0 mt-lg-0 mt-md-0 mt-3 mb-xl-0 mb-lg-0 mb-md-0 pb-3" style={{ borderBottom: '2px solid white' }}>
            <span className="customFontSizeTitulos ml-3 text-white "> Filtros </span>
            <img
              src={cruzBlanca}
              alt="login-icon"
              className="card-img-top"
              style={{ position:'absolute', height: '3rem', width: '3rem', cursor:'pointer', top:0 , right:0 }}
              onClick={onClose}
            />
          </div>
        </div>
        <div className="container-fluid d-flex justify-content-center p-0">
          <div className="col-6" style={{ borderRight: '2px solid white' }}>
            <div className="container-fluid mt-1 p-0">
              <div className="row-fluid justify-content-start d-flex">
                <span className="customFontSizeTitulos ml-xl-3 ml-lg-3 ml-md-2 ml-0 pb-1 text-white" style={{fontWeight: 'bold'}}> Género </span>
              </div>
              <div className='container-fluid p-0'>
                  <div className='row-fluid text-start d-flex pb-1'>
                      <div className='col-6 d-flex'> 
                          <span className="customFontSizeTextoNormal ml-xl-4 ml-lg-4 ml-md-2 ml-0 text-white"> Hombre </span>
                      </div>
                      <div className='ml-4 mt-1'>
                          <ToggleButton
                          selected={selectedHombre}
                          toggleSelected={handleToggleHombre}
                          />
                      </div>
                  </div>
                  <div className='row-fluid text-start d-flex pb-1'>
                      <div className='col-6 d-flex'> 
                          <span className="customFontSizeTextoNormal ml-xl-4 ml-lg-4 ml-md-2 ml-0 text-white"> Mujer </span>
                      </div>
                      <div className='ml-4 mt-1'>
                          <ToggleButton
                          selected={selectedMujer}
                          toggleSelected={handleToggleMujer}
                          />
                      </div>
                  </div>
                  <div className='row-fluid text-start d-flex pb-1'>
                      <div className='col-6 d-flex'>
                          <span className="customFontSizeTextoNormal ml-xl-4 ml-lg-4 ml-md-2 ml-0 text-white"> Otro </span>
                      </div>
                      <div className='ml-4 mt-1'>
                          <ToggleButton
                          selected={selectedOtro}
                          toggleSelected={handleToggleOtro}
                          />
                      </div>
                  </div>
              </div>
            </div>
            <div className='row' style={{height:'1.5rem'}}></div>
            <div className="container-fluid p-0">
              <div className="row-fluid justify-content-start d-flex">
                <span className="customFontSizeTitulos ml-xl-3 ml-lg-3 ml-md-2 ml-0 pb-1 text-white" style={{fontWeight: 'bold'}}> Promoción </span>
              </div>
              <div className='container-fluid p-0'>
                  <div className='row-fluid text-start d-flex pb-1'>
                      <div className='col-6 d-flex'>
                          <span className="customFontSizeTextoNormal ml-xl-4 ml-lg-4 ml-md-2 ml-0 text-white"> Primera </span>
                      </div>
                      <div className='ml-4 mt-1'>
                          <ToggleButton
                          selected={selectedPrimera}
                          toggleSelected={handleTogglePrimera}
                          />
                      </div>
                  </div>
                  <div className='row-fluid text-start d-flex pb-1'>
                      <div className='col-6 d-flex'>
                          <span className="customFontSizeTextoNormal ml-xl-4 ml-lg-4 ml-md-2 ml-0 text-white"> Segunda </span>
                      </div>
                      <div className='ml-4 mt-1'>
                          <ToggleButton
                          selected={selectedSegunda}
                          toggleSelected={handleToggleSegunda}
                          />
                      </div>
                  </div>
                  <div className='row-fluid text-start d-flex pb-1'>
                      <div className='col-6 d-flex'> 
                          <span className="customFontSizeTextoNormal ml-xl-4 ml-lg-4 ml-md-2 ml-0 text-white"> Tercera </span>
                      </div>
                      <div className='ml-4 mt-1'>
                          <ToggleButton
                          selected={selectedTercera}
                          toggleSelected={handleToggleTercera}
                          />
                      </div>
                  </div>
                  <div className='row-fluid text-start d-flex pb-1'>
                      <div className='col-6 d-flex'> 
                          <span className="customFontSizeTextoNormal ml-xl-4 ml-lg-4 ml-md-2 ml-0 text-white"> Cuarta </span>
                      </div>
                      <div className='ml-4 mt-1'>
                          <ToggleButton
                          selected={selectedCuarta}
                          toggleSelected={handleToggleCuarta}
                          />
                      </div>
                  </div>
                  <div className='row-fluid text-start d-flex pb-1'>
                      <div className='col-6 d-flex'> 
                          <span className="customFontSizeTextoNormal ml-xl-4 ml-lg-4 ml-md-2 ml-0 text-white"> Quinta o + </span>
                      </div>
                      <div className='ml-4 mt-1'>
                          <ToggleButton
                          selected={selectedQuinta}
                          toggleSelected={handleToggleQuinta}
                          />
                      </div>
                  </div>
              </div>
            </div>
            <div className="container-fluid p-0">
              <div className="row-fluid d-flex mt-4 p-4 align-items-center flex-column flex-md-row">
                <span className="customFontSizeNormal pb-1 text-white text-nowrap" style={{ fontWeight: 'bold' }}> Ordenar colegiales </span>
                <select
                  value={ordenacion}
                  onChange={(e) => setOrdenacion(e.target.value)}
                  className="form-control mt-2 mt-md-0"
                  style={{ flex: '1', marginLeft: '1rem' }}
                >
                  <option value="nombre">Nombre</option>
                  <option value="apellido">Apellido</option>
                  <option value="promocion">Promoción</option>
                </select>
              </div>
            </div>
          </div>
          <div className="col-6">
          <div className="container-fluid mt-1">
              <div className="row-fluid justify-content-start d-flex">
                <span className="customFontSizeTitulos ml-xl-3 ml-lg-3 ml-md-2 ml-0 pb-1 text-white" style={{fontWeight: 'bold'}}> Pasillo </span>
              </div>
              <div className='container-fluid'>
                  <div className='row-fluid text-start d-flex pb-1'>
                      <div className='col-6 d-flex'>
                          <span className="customFontSizeTextoNormal ml-xl-4 ml-lg-4 ml-md-2 ml-0 text-white"> 100s </span>
                      </div>
                      <div className='ml-4 mt-1'>
                          <ToggleButton
                          selected={selected100}
                          toggleSelected={handleToggle100}
                          />
                      </div>
                  </div>
                  <div className='row-fluid text-start d-flex pb-1'>
                      <div className='col-6 d-flex'>
                          <span className="customFontSizeTextoNormal ml-xl-4 ml-lg-4 ml-md-2 ml-0 text-white"> 200s </span>
                      </div>
                      <div className='ml-4 mt-1'>
                          <ToggleButton
                          selected={selected200}
                          toggleSelected={handleToggle200}
                          />
                      </div>
                  </div>
                  <div className='row-fluid text-start d-flex pb-1'>
                      <div className='col-6 d-flex'>
                          <span className="customFontSizeTextoNormal ml-xl-4 ml-lg-4 ml-md-2 ml-0 text-white"> 300s </span>
                      </div>
                      <div className='ml-4 mt-1'>
                          <ToggleButton
                          selected={selected300}
                          toggleSelected={handleToggle300}
                          />
                      </div>
                  </div>
                  <div className='row-fluid text-start d-flex pb-1'>
                      <div className='col-6 d-flex'>
                          <span className="customFontSizeTextoNormal ml-xl-4 ml-lg-4 ml-md-2 ml-0 text-white"> 400s </span>
                      </div>
                      <div className='ml-4 mt-1'>
                          <ToggleButton
                          selected={selected400}
                          toggleSelected={handleToggle400}
                          />
                      </div>
                  </div>
              </div>
            </div>
            <div className='row-fluid p-0' style={{height:'1.5rem'}}></div>
            <div className="container-fluid p-0 mt-3">
              <div className="containers-fluid justify-content-start d-flex p-0">
                  <div className='col-7 d-flex'>
                      <span className="customFontSizeTextoNormal ml-xl-3 ml-lg-3 ml-md-2 ml-0 pb-3 text-white" style={{fontWeight: 'bold'}}> Sólo adjuntos a la dirección </span>
                  </div>
                  <div className='ml-xl-4 ml-lg-4 ml-md-3 ml-1 mt-4'>
                      <ToggleButton
                      selected={selectedAdjuntos}
                      toggleSelected={handleToggleAdjuntos}
                      />
                  </div>
              </div>
              <div className="container-fluid d-flex mt-4 justify-content-start p-0">
                  <div className='col-7'>
                      <div>
                          <span className="customFontSizeTextoNormal ml-xl-3 ml-lg-3 ml-md-2 ml-0 pb-3 text-white" style={{fontWeight: 'bold'}}> Sólo favoritos </span>
                      </div>
                      <div>
                          <img
                              src={favoritosBlanco}
                              alt="login-icon"
                              className="card-img-top"
                              style={{ height: '2rem', width: '2rem',cursor:'pointer' }}
                              onClick={onClose}
                          />
                      </div>
                  </div>
                  <div className='ml-xl-3 ml-lg-3 ml-md-3 ml-1 mt-4 pl-2'>
                      <ToggleButton
                      selected={selectedFavoritos}
                      toggleSelected={handleToggleFavoritos}
                      />
                  </div>
              </div>
              <div className='row-fluid p-4 mt-4 justify-content-center'>
                  <button 
                    style={{ backgroundColor: '#D9D9D9', borderRadius: '5px', padding: '10px 20px', border: 'none', cursor: 'pointer', fontFamily: 'Roboto Slab, sans-serif' }}
                    onClick={vaciarFiltros}>
                      VACIAR
                  </button>
              </div>
            </div>
          </div>
        </div>
      </div>
   </div>
    );
};

export default Filtros;
